import { createFileRoute, notFound } from '@tanstack/react-router';
import { NotFound } from '../-components/not-found';

export const Route = createFileRoute('/old/$')({
	// Only a LOADER's `notFound()` makes the HTML answer 404; see www/$.tsx.
	loader: () => {
		throw notFound();
	},
	// Not `DefaultGlobalNotFound`: without `<title>` or `robots` its 404s were anonymous in GA4 and indexable.
	notFoundComponent: RouteComponent,
	component: RouteComponent,
});

function RouteComponent() {
	return <NotFound />;
}
